import React, { useState } from 'react';

import {
  FieldsContainer,
  DescriptionQuillContainer,
  ErrorMessage,
  TextInput,
} from '../../containers/SettingsPage/styles';
import { Button } from '../';
import { websiteRegex, phoneNumberRegex } from '../../../util/appConstants';
import QuillEditor from '../../../components/QuillEditor/quillEditorEmail';

export default function DepartmentSetting({
  department,
  updateDepartment,
  createDepartment,
  isModal,
  isDepartmentSettingsPage,
}) {
  const [name, setName] = useState(department.name || '');
  const [website, setWebsite] = useState(department.website || '');
  const [phone, setPhone] = useState(department.phone || '');
  const [country, setCountry] = useState(department.country || '');
  const [city, setCity] = useState(department.city || '');
  const [description, setDescription] = useState(department.description || '');
  const [formError, setFormError] = useState('');

  const validateForm = () => {
    if (!name) setFormError('Department name is required');
    else if (website && !website.match(websiteRegex)) setFormError('Website is not valid');
    else if (phone && !String(phone).match(phoneNumberRegex)) setFormError('Phone number is not valid');
    else {
      setFormError('');
      return true;
    }
  };

  const saveDepartment = async () => {
    let isValidForm = validateForm();
    if (isValidForm) {
      if (isModal) createDepartment({ name, website, phone, country, city, description });
      else updateDepartment({ name, website, phone, country, city, description });
    }
  };

  return (
    <>
      <FieldsContainer>
        <TextInput
          isEditing={isDepartmentSettingsPage ? true : department.default ? false : true}
          margin="15px 0 0 0"
          padding="5px"
          placeholder="Name*"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextInput
          isEditing={true}
          margin="15px 0 0 0"
          padding="5px"
          placeholder="Website"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
        />
        <TextInput
          isEditing={true}
          margin="15px 0 0 0"
          padding="5px"
          placeholder="Phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <TextInput
          isEditing={true}
          margin="15px 0 0 0"
          padding="5px"
          placeholder="Country"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        />
        <TextInput
          isEditing={true}
          margin="15px 0 0 0"
          padding="5px"
          placeholder="City"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        {/* <TextInput isEditing={true} margin="15px 0 0 0" padding="5px" placeholder="Language" /> */}
      </FieldsContainer>
      <DescriptionQuillContainer>
        <QuillEditor
          placeholder="Description"
          value={description}
          onChange={(updatedValue) => setDescription(updatedValue)}
        />
      </DescriptionQuillContainer>
      {formError && <ErrorMessage>{formError}</ErrorMessage>}
      <Button
        small
        primaryBlue
        primaryGreenBorder
        removeMargin
        margin="10px 10px 0 10px"
        textAlign={isModal ? 'right' : 'left'}
        onClick={() => saveDepartment()}
      >
        Save
      </Button>
    </>
  );
}
